import { Cell } from "./weeklyContainer";
import * as React from "react";
import { useRef } from "react";
import { useDrop } from "react-dnd";
import { theme } from "styles/theme";
import { format } from "date-fns";

type Props = {
  newDate: Date;
  crewId: string;
  children: React.ReactNode;
  appointmentMoved: any;
  className?: any;
};
export default function DroppableCell({
  newDate,
  crewId,
  children,
  appointmentMoved,
  className,
}: Props) {
  const newDateRef = useRef(newDate);
  const crewIdRef = useRef(crewId);
  newDateRef.current = newDate;  
  crewIdRef.current = crewId;

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: "BOX",
      drop: ({ id, date: prevDate, prevUserId }: any) => {
   
        appointmentMoved.mutate({
          prevDate,
          date: format(newDateRef.current, "yyyy-MM-dd"),
          id,
          prevUserId,
          userId: crewIdRef.current, 
        });
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    []
  );

  return (
    <Cell
      ref={drop}
      style={{ background: isOver ? theme.bg.blue : "transparent" }}
      className={className}
    >
      {children}
    </Cell>
  );
}
